<template>
  <!--<li class="relative flex w-full card-image-links" :class="oneEveryRow ? 'w-full mb-6 md:mb-8' : twoEveryRow ? 'md:w-1/2 my-3 sm:px-3' : 'md:w-1/3 my-3 sm:px-3'">-->
  <div class="relative flex-1 bg-white cursor-pointer rounded-xl border-1 border-newColors-gray-baseB rounded-card-item group hover:border-newColors-gray-contentD" :class="[useWhiteBg ? 'bg-white' : 'bg-gray-ultralight', adjustMinHeight].join(' ')">
    <div class="h-full overflow-hidden">
      <a :href="linkUrl" class="flex flex-col h-full focus:outline-black-alt" :class="[oneCol ? 'md:flex-row' : '', adjustMinHeight].join(' ')">
        <div v-if="imageUrl" class="relative overflow-hidden rounded-t-xl" :class="oneCol ? 'md:max-w-sm-medium' : ''">
          <div class="absolute top-0 bottom-0 left-0 right-0 z-10 bg-overlay-gradient"></div>

          <figure v-if="mediaflow" class="flex-none object-cover w-full overflow-hidden transition duration-500 ease-out transform aspect-video group-hover:scale-105">
            <img :src="mediaflow.imageUrl" :alt="mediaflow.altText" />
            <figcaption v-if="mediaflow.photographer" class="h-0 text-transparent">
              <cite>{{ mediaflow.photographer }}</cite>
            </figcaption>
          </figure>

          <img v-if="!mediaflow && imageUrl" class="flex-none object-cover w-full overflow-hidden transition duration-500 ease-out transform aspect-video group-hover:scale-105" :src="imageUrl" />
        </div>
        <div
          class="relative flex flex-col items-baseline flex-grow w-full overflow-hidden"
          :class="
            [
              adjustHeight,
              company ? 'mb-5' : 'mb-0',
              noPaddingX ? 'px-0' : 'px-3',
              oneCol ? 'pt-6 md:py-0 md:pl-6 justify-center' : 'pt-2.5 pb-4',
              company && companyType === 1 ? 'bg-gray-green !px-5' : company && companyType === 2 ? 'bg-gray-ultralight  !px-5' : ''
            ].join(' ')
          ">
          <p v-if="date" class="mb-2 text-lg leading-4 md:mb-0 text-green-dark md:leading-8 font-futuraEfDemiBold">
            <time class="pr-2 mr-2 border-r-2 border-green-dark font-futuraEfDemiBold" :datetime="date">{{ dateText }}</time>
            {{ tag }}
          </p>
          <div v-if="heading">
            <p class="mb-2 font-futuraEfDemiBold text-newColors-gray-content" :class="largeHeading ? (twoCol ? 'text-2xl' : 'text-xl') : 'text-xl'">
              {{ getStringWithoutLastWord(heading) }} <span class="web-link-icon">{{ getLastWordOfString(heading) }} </span>
            </p>
          </div>
          <p v-if="heading && !withoutText" class="mb-6 text-lg text-newColors-gray-contentA word-break">{{ text }}</p>
          <p v-if="!heading && !withoutText" class="mb-6 text-xl text-newColors-gray-contentA">
            {{ getStringWithoutLastWord(text) }} <span class="web-link-icon web-link-icon--small text-newColors-gray-contentA">{{ getLastWordOfString(text) }} </span>
          </p>
          <div v-if="!withoutText" class="fade-overlay"></div>
        </div>
        <div v-if="company" class="flex mb-4 ml-3">
          <p class="w-auto px-3 py-1 mt-auto text-base rounded-lg" :class="company === 'Ellevio AB' ? 'bg-newColors-gray-background' : 'bg-newColors-orange-secondaryB'">{{ company }}</p>
        </div>
      </a>
    </div>
    <!--<div class="fade-overlay"></div>-->
  </div>
  <!--</li>-->
</template>

<script>
export default {
  name: 'EllevioWebRoundedCardImageItem',
  props: {
    numberOfColumns: {
      type: Number,
      default: 3
    },
    twoEveryRow: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    useWhiteBg: {
      type: Boolean,
      default: false
    },
    noPaddingX: {
      type: Boolean,
      default: false
    },
    largeHeading: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      default: ''
    },
    dateText: {
      type: String,
      default: ''
    },
    mediaflow: {
      type: Object
    },
    imageUrl: {
      type: String
    },
    linkUrl: {
      type: String
    },
    tag: {
      type: String,
      default: ''
    },
    company: {
      type: String,
      default: ''
    },
    companyType: {
      type: Number,
      default: 0
    }
  },
  computed: {
    withoutText() {
      return this.text === null || this.text === ''
    },
    oneCol() {
      return this.numberOfColumns === 1
    },
    twoCol() {
      return this.numberOfColumns === 2
    },
    threeCol() {
      return this.numberOfColumns === 3
    },
    adjustMinHeight() {
      if (this.withoutText) {
        return 'md:min-h-[24rem]'
      } else if (this.threeCol) {
        return 'md:min-h-[34.875rem]'
      } else if (this.twoCol) {
        return 'md:min-h-[39.6875rem]'
      } else {
        return ''
      }
    },
    adjustHeight() {
      if (this.withoutText) {
        return 'md:h-[7.8125rem]'
      } else if (this.threeCol) {
        return 'md:h-[10rem]'
      } else if (this.twoCol) {
        return 'md:h-[17.5rem]'
      } else {
        return ''
      }
    }
  },
  methods: {
    getStringWithoutLastWord(str) {
      let words = str.split(' ')
      let lastWord = words.pop()
      while (lastWord === '' && words.length > 0) {
        lastWord = words.pop()
      }
      return words.join(' ')
    },
    getLastWordOfString(str) {
      let words = str.split(' ')
      let lastWord = words.pop()
      while (lastWord === '' && words.length > 0) {
        lastWord = words.pop()
      }
      return lastWord
    }
  }
}
</script>
<style scoped>
.word-break {
  word-break: break-word;
}
.fade-overlay {
  height: 3.4375rem;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(rgba(255, 255, 255, 0) 0px, rgb(255, 255, 255) 80%);
  z-index: 10;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.rounded-card-item:hover {
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
}
</style>
